import * as React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  getLeads,
  removeJob,
  initializeJobData,
} from '../data/jobs/jobActions';
import { leadsSelector } from '../data/jobs/jobSelectors';
import {
  createCanGetMore,
  createIsLoading,
  createDidError,
} from '../data/requests/requestsSelectors';
import { JobListingLayout } from './static/Layouts';
import CreateLead from './static/CreateLead';
import JobList from './AgencyPostings/JobList';
import Header from './static/Header';
import Modal from './static/Modal';
import Icon from './static/Icons';
import { Button } from './static/Elements';

import createLogger from '../utils/createLogger';

const DEBUG = false;
const debug = createLogger(DEBUG, `JobLeads.js`);


class JobLeads extends React.Component {

  static dependencies = [
    `GET_JOB_LEADS_PAGE`,
    `PUT_JOB`,
  ];

  static propTypes = {
    get: PropTypes.func.isRequired,
    jobs: PropTypes.array.isRequired,
    didError: PropTypes.bool.isRequired,
    removeJob: PropTypes.func.isRequired,
    canGetMore: PropTypes.bool.isRequired,
    isLoading: PropTypes.bool.isRequired,
    createJobLead: PropTypes.func,
  };

  /* ------------ lifecycle methods ------------ */
  constructor(props) {
    super(props);
    debug.enter(`constructor`);

    this.state = {
      modalIsOpen: false,
    }
  }

  componentDidMount() {
    const {
      isAuthenticated,
      initializeJobData,
    } = this.props;
    debug.enter(`componentDidMount`);

    if (isAuthenticated) {
      debug.log(`  calling initializeJobData`);
      initializeJobData();
    }
  };


  /* ------------ event handlers ------------ */
  openModal = () => this.setState({modalIsOpen: true});
  closeModal = () => this.setState({modalIsOpen: false});

  onSubmitCreateLead = (title, company_url, agency_url) => {
    const { closeModal } = this;

    closeModal();
  };

  onRemove = (id) => () => {
    const { removeJob } = this.props;
    removeJob(id, 'closed');
  };

  /* ------------ render methods ------------ */
  render() {
    const {
      onSubmitCreateLead,
      closeModal,
      openModal,
      onRemove,
    } = this;
    const {
      canGetMore,
      isLoading,
      didError,
      jobs,
      get,
    } = this.props;
    const { modalIsOpen } = this.state;

    debug.enter(`render`);
    debug.log(`  isLoading: ${isLoading}`);
    debug.log(`  didError: ${didError}`);
    debug.log(`  jobs: ${jobs.length}`);

    const listConfig = {
      type: 'leads',
      get,
      jobs,
      title: `Job Leads`,
      didError,
      isLoading,
      canGetMore,
      onRemove,
    };

    return (
      <JobListingLayout>
        <Modal title="Create New Lead"
               isOpen={modalIsOpen}
               close={closeModal}>
          <CreateLead onSubmit={onSubmitCreateLead}
                      onCancel={closeModal}/>
        </Modal>

        <Header top>
        </Header>

        <JobList {...listConfig}>
          <Button primary onClick={openModal}>
            <Icon.Add/> Add New Lead
          </Button>
        </JobList>

      </JobListingLayout>
    );
  }
}


/* ------------ redux connect ------------ */
const mapStateToProps = (state) => {
  const canGetMore = createCanGetMore(JobLeads.dependencies[0]);
  const isLoading = createIsLoading(JobLeads.dependencies);
  const didError = createDidError(JobLeads.dependencies);

  return {
    isAuthenticated: !!state.auth.session,
    jobs: leadsSelector(state),
    canGetMore: canGetMore(state),
    isLoading: isLoading(state),
    didError: didError(state),
  }
};

export default connect(mapStateToProps, {
  get: getLeads,
  removeJob,
  initializeJobData,
})(JobLeads);




// WEBPACK FOOTER //
// ./src/components/JobLeads.js